var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-view"},_vm._l((_vm.images),function(img){return _c('img',{key:img,attrs:{"src":img,"alt":""},on:{"click":function($event){return _vm.handlePreview([img])}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }